import { GetterTree } from "vuex";
import { RootState } from "../types";
import { StripesInt } from "./types";
export const getters: GetterTree<StripesInt, RootState> = {};
